<template>
  <page-with-back-btn title="Saved Orders">
      <DateRangeSelector :submit-method="loadAllData" class="mb-3"/>
      <form class="mx-2" @submit.prevent="loadAllData">
        <div class="row mb-2">
          <div class="col-md-3">
            <div class="form-floating ">
              <input type="text" class="form-control"
                     v-model="form.quoteNumber" id="quoteNumber"
                     placeholder="Quote No.">
              <label for="quoteNumber">Quote No.</label>
            </div>
          </div>

          <div class="col-md-3">
            <div class="form-floating">
              <input type="text" class="form-control"
                     v-model="form.customerName" id="customerName"
                     placeholder="Customer Name">
              <label for="customerName">Customer Name</label>
            </div>
          </div>

          <div class="col-md-3">
            <div class="form-floating ">
              <input type="text" class="form-control"
                     v-model="form.Name" id="Quote Reference"
                     placeholder="Quote Reference">
              <label for="Quote Reference">Quote Reference</label>
            </div>
          </div>

          <div class="col-md-3">
            <div class="form-floating ">
              <input type="number" class="form-control" required
                     v-model="form.limit" id="debtorLimit"
                     placeholder="Limit">
              <label for="debtorLimit">Limit</label>
            </div>
          </div>
        </div>

        <button type="submit" class="lyt-soft-btn w-100">
          <font-awesome-icon icon="fa-solid fa-search"/>
          Search
        </button>
      </form>

      <div class="card m-3">
        <label class="card-header text-primary">
          <b style="text-underline: black">Quotes</b>
          <h5 :class="quotedTotal > 0?`mx-3 badge bg-success`:`mx-3 badge bg-warning`">TOTAL QUOTED :
            {{ $utils.formatMoney(quotedTotal) }}</h5>
        </label>

        <div class="card-body d-flex flex-column">
          <QuoteRecord v-for="quote in quotes" :quote="quote" class="mb-2" @click="openTable" />
        </div>

        <OpenTableSheet ref="tableSheet" :tab="setTable"/>

      </div>

  </page-with-back-btn>
</template>

<script>

import PageWithBackBtn from "@/components/layout/utils/PageWithBackBtn";
import DateRangeSelector from "@/components/layout/utils/DateRangeSelector";
import QuoteRecord from "@/components/point-of-sale/Accounts/QuoteRecord";
import OpenTableSheet from "@/components/point-of-sale/table/OpenTableSheet";

export default {
  name: "Quotes",
  components: {OpenTableSheet, QuoteRecord, DateRangeSelector, PageWithBackBtn},
  beforeMount() {
    this.loadAllData();
  },
  data() {
    return {
      setTable: {},
      form: {
        Name: "",
        customerName: "",
        quoteNumber: "",
        limit: 50,
        orderBy: {
          field: 'created',
          direction: 'desc'
        },
      },
      quotes: [],
      quotedTotal: 0.00,
    }
  },
  methods: {
    loadAllData() {
      this.$utils.showLoading()
      return Promise.all([
        this.getAllQuotes(),
        this.getQuotedTotal()
      ]).finally(() => this.$utils.hideLoading())
    },
    openTable(saleNumber) {
      this.$utils.showLoading();
      return this.$store.dispatch(`getTableData`, saleNumber).then(res=>{
        this.setTable = res
        this.$refs.tableSheet.open();
      }).finally(()=> this.$utils.hideLoading())
    },
    getAllQuotes() {
      return this.$store.dispatch('getAllQuotes', this.form)
          .then(res => this.quotes = res)
    },
    getQuotedTotal() {
      return this.$store.dispatch('getQuotedTotal')
          .then(res => this.quotedTotal = res)
    },
  }
}
</script>
<style lang="scss" scoped>
.col-md-4 {
  margin-bottom: 10px;
}
</style>